const Translation = {
  en: {
    translation: {
      '#': undefined,
      '(Missions) for New License Account Only': 'Missions for New License Account Only',
      '(Stellar Box) for New License Account Only': 'Stellar Box for New License Account Only',
      '(your bank account)': undefined,
      '(your bank name)': undefined,
      '{{count}} members': undefined,
      '{{count}} new': undefined,
      '{{count}} unread': undefined,
      '{{filled}} of {{requested}} filled': undefined,
      '{{WatchlistName}} is coming soon': '{{WatchlistName}} is coming soon. Don\'t miss out.',
      '-': undefined,
      '3 Months': undefined,
      '6 Months': undefined,
      '7 Days': undefined,
      '12 Months': undefined,
      '30 Days': undefined,
      '52 Weeks High/Low': undefined,
      'A fixed ratio will be applied to all your copied trades': 'A fixed ratio will be applied to all your copied trades. For example: if you set a 10% ratio, when the Ace uses $100 of equity for a trade, you will use $10 of equity.',
      'About': undefined,
      'Account': undefined,
      'Account / card number': undefined,
      'Account holder\'s name': undefined,
      'Account Name': undefined,
      'Account number': undefined,
      'Account Number': undefined,
      'Account Settings': undefined,
      'Account type': undefined,
      'Account verified': undefined,
      'Active': undefined,
      'Active Copy Funds': undefined,
      'Active Copy Funds Def': 'The total Copy Funds allocated by current copiers to copy this Ace.',
      'Active Kaptain': 'Active Ace',
      'Active Kaptains': 'Active Aces',
      'Active sessions': undefined,
      'Activity': undefined,
      'Actual': undefined,
      'Add a bank account for withdrawal.': undefined,
      'Add a CapitalPay bank account': undefined,
      'add a number': undefined,
      'add a special character': undefined,
      'Add alerts': undefined,
      'Add favourites in': 'Add favourites in <1>Markets</1> now',
      'Add members': undefined,
      'Add screenshots': undefined,
      'add upper & lowercase letters': undefined,
      'Additional comments': undefined,
      'Admin': undefined,
      'Administrator': undefined,
      'Admins': undefined,
      'Alert number': 'Alert {{index}}',
      'All': undefined,
      'All closed trades': undefined,
      'All Currency Pairs': undefined,
      'All Followers': undefined,
      'All Instruments': undefined,
      'All rights reserved.': undefined,
      'All transactions': undefined,
      'Alphie Trader.': undefined,
      'Already a member?': undefined,
      'Amount': undefined,
      'Amount Left': '{{amount}} Left',
      'Amount sent to you': undefined,
      'Amount Using': '{{amount}} Using',
      'Appearance': undefined,
      'Application Pending': undefined,
      'Are you sure you want to close all your instrument trades?': 'Are you sure you want to close all your {{instrument}} trades?',
      'Are you sure you want to close all your trades?': undefined,
      'Are you sure you want to close your stacked trades?': undefined,
      'Are you sure you want to close your trade?': undefined,
      'Are you sure you want to delete this comment? This action cannot be undone.': undefined,
      'Are you sure you want to delete this post? This action cannot be undone.': undefined,
      'Are you sure you want to partial close your trade?': undefined,
      'Are you sure you want to place your order?': undefined,
      'Are you sure you want to stop Auto-pilot?': undefined,
      'Are you sure you want to stop copying this trader': undefined,
      'Area': undefined,
      'Ask': undefined,
      'Ask me before closing a single trade': undefined,
      'Ask me before closing stacked trades': undefined,
      'Ask me before opening a trade': undefined,
      'At least 8 characters': undefined,
      'At least 8 characters, 64 maximum': undefined,
      'at market': undefined,
      'Attach files': undefined,
      'Auto-pilot': undefined,
      'Auto-Pilot is on': undefined,
      'Auto-pilot will automatically close your copied trade at market price when the Kaptain closes theirs.': 'Auto-pilot will automatically close your copied trade at market price when the Ace closes theirs.',
      'Avatar removed successfully': undefined,
      'Average copied trade size': 'Average equity used per copied trade {{averageCopiedTradeSize}}',
      'Average trade size is larger than your Copy Fund': 'Average equity used per copied trade is larger than your Copy Fund.\nTrades that exceed your unused Copy Fund will be copied at a reduced size. If the affordable size is too small to place, the trade will not be copied.',
      'Avg. Active Copy Funds': undefined,
      'Avg. Closed Price': undefined,
      'Avg. Copy Funds Used': undefined,
      'Avg. Equity Used': undefined,
      'Avg. Equity Used Definition': 'Average margin used per closed trade in this period, as a percentage of current total equity.',
      'Avg. Holding Period': undefined,
      'Avg. Loss % per Trade': undefined,
      'Avg. Loss % per Trade Definition': 'Average return on margin of the losing trades closed in this period.',
      'Avg. Open': undefined,
      'Avg. Open Price': undefined,
      'Avg. P/L': undefined,
      'Avg. Past Copy Funds Used': undefined,
      'Avg. Size': undefined,
      'Avg. Win % per Trade': undefined,
      'Avg. Win % per Trade Definition': 'Average return on margin of the winning trades closed in this period.',
      'Back to home': undefined,
      'Back to sign in': undefined,
      'Badges': undefined,
      'Balance': undefined,
      'Bank': undefined,
      'Bank Account': undefined,
      'Bank Account Add button': '+ Bank Account',
      'Bank account saved': undefined,
      'Bank Accounts': undefined,
      'Bank Accounts contact our support': 'Please <0>contact our support</0> if you need to change or remove bank account details.',
      'Bank Address': undefined,
      'Bank Address cannot be empty': 'Bank Address cannot be empty',
      'Bank Code': undefined,
      'Bank Deposit': undefined,
      'Bank Name': undefined,
      'Bank name': undefined,
      'Bank Name cannot be empty': 'Bank Name cannot be empty',
      'Bank Transfer': undefined,
      'Banks': undefined,
      'Best Trade': undefined,
      'Bid': undefined,
      'Bio': undefined,
      'Block': undefined,
      'Blog': undefined,
      'Blog post': undefined,
      'Branch Code': undefined,
      'Browser push notifications': undefined,
      'Browser push notifications blocked': 'Notifications blocked. Please turn on browser notifications for Alphie Trader',
      'Browser push notifications coming soon': "Coming soon — browser push notifications are temporarily unavailable while we sort things out.",
      'Browser push notifications helper text': "Get notified even when Alphie Trader isn't open in your browser.",
      'Buy': undefined,
      'Buy Limit': undefined,
      'Buy Stop': undefined,
      'By Kaptain': 'By Ace',
      'By signing up, you agree to our Terms & Conditions and Privacy Policy': 'By signing up, you agree to our <2>Terms & Conditions</2> and <6>Privacy Policy</6>',
      'Calendar': undefined,
      'Campaign': undefined,
      'Campaign Ended': undefined,
      'Campaign ended': undefined,
      'Campaign ends in:': undefined,
      'Campaign reward': '{{maximumReward}} in prizes awaiting your discovery',
      'Campaign starts in:': undefined,
      'Cancel': undefined,
      'Cancel Order': undefined,
      'Cancel repost': 'Cancel repost',
      'Candle': undefined,
      'CapitalPay': undefined,
      'CapitalPay - Bank': undefined,
      'CapitalPay - QR': undefined,
      'CapitalPay account': undefined,
      'CapitalPay bank': undefined,
      'CapitalPay Details': undefined,
      'Categories': undefined,
      'Change': undefined,
      'Change Avatar': undefined,
      'Change copy limit': undefined,
      'Change copy limits': undefined,
      'Change Cover Photo': undefined,
      'Change group photo': undefined,
      'Change limits': undefined,
      'Channel list': undefined,
      'Character Left': undefined,
      'Characters Left': undefined,
      'Chart': undefined,
      'Chat': undefined,
      'Chat empty': 'Choose from your existing conversations or start a new chat.',
      'Chat new': 'Start a new chat',
      'Chat now': 'Start a chat now',
      'Chats': undefined,
      'Check your email': undefined,
      'Choose a strong password': undefined,
      'Choose a subject': undefined,
      'Choose deposit method': undefined,
      'Choose how Alphie Trader looks on this device.': undefined,
      'Clear': undefined,
      'Close': undefined,
      'Close All': undefined,
      'Close At Market Price': undefined,
      'Close emoji picker': undefined,
      'Close Failed': undefined,
      'Close Position Failed because': 'Close Position Failed because the market is closed. Please try again later.',
      'Close Price': undefined,
      'Close Time': undefined,
      'Close volume should not be greater than {{value}}': undefined,
      'Close volume should not be less than {{value}}': undefined,
      'Closed': undefined,
      'Closed By Kaptain': 'Closed By Ace',
      'Closed copied trades': undefined,
      'Closed Event': undefined,
      'Closed Price': undefined,
      'Closed Trade': undefined,
      'Closed Trades': undefined,
      'Closing {{percent}}% of your trade': undefined,
      'Closing is unavailable while the market is closed.': undefined,
      'Coming Soon': undefined,
      'Commodities': undefined,
      'Complete KYC to unlock live trading': undefined,
      'Conditions': undefined,
      'Confirm close stacked trades': undefined,
      'Confirm close trade': undefined,
      'Confirm partial close trade': undefined,
      'Confirm Password': undefined,
      'Confirm your order': undefined,
      'Confirm your password': undefined,
      'Congrats! You won': '🎉 Congrats! You won',
      'Consensus': undefined,
      'Contact us': undefined,
      'Continue': undefined,
      'Continue in browser': undefined,
      'Continue reading': undefined,
      'Conversion rate': undefined,
      'Conversion rate is indicative': 'Conversion rate is indicative only and may be subject to change.',
      'Copied': undefined,
      'Copied Kaptains': 'Copied Aces',
      'Copied to clipboard': undefined,
      'Copier Limit Exceeded': undefined,
      'Copier_Interval': '(0)[copiers];(1)[copier];(2-inf)[copiers];',
      'Copiers': undefined,
      'Copiers\' Return': undefined,
      'Copiers\' Return Definition': 'The total P/L of current and past copiers of this Ace, divided by the equity they used for their closed copied trades (Total Copy Funds Used).',
      'Copy': undefined,
      'Copy Fee': undefined,
      'Copy Fund': undefined,
      'Copy Fund cannot be 0': undefined,
      'Copy Fund cannot be less than equity using by Kaptain': 'Copy Fund cannot be less than equity using by Ace',
      'Copy Fund is negative': 'Your Copy Fund for this Ace is negative. New trades will not be copied.',
      'Copy Fund is the total equity used to copy this Kaptain': 'Copy Fund is the total equity used to copy this Ace. It will be adjusted according to the realized P/L of your copied trades.',
      'Copy limits updated': undefined,
      'Copy Link': undefined,
      'Copy link to {{where}}': 'Copy link to {{where}}',
      'Copy Payout': undefined,
      'Copy trade failed': undefined,
      'Copy Trading': undefined,
      'Copy Trading Kaptains': 'Copy <1>Trading Aces</1>',
      'Copy Trading Rules': undefined,
      'Copying': undefined,
      'Copying since': 'Copying since {{date}}',
      'Country': undefined,
      'Country Not Supported': undefined,
      'Country Not Supported Message': 'Deposit from your country is currently not supported.\nPlease try again later.',
      'Country_AE': 'United Arab Emirates',
      'Country_AR': 'Argentina',
      'Country_AT': 'Austria',
      'Country_AU': 'Australia',
      'Country_BE': 'Belgium',
      'Country_BR': 'Brazil',
      'Country_CA': 'Canada',
      'Country_CH': 'Switzerland',
      'Country_CL': 'Chile',
      'Country_CN': 'China',
      'Country_CO': 'Colombia',
      'Country_CZ': 'Czech Republic',
      'Country_DE': 'Germany',
      'Country_DK': 'Denmark',
      'Country_EG': 'Egypt',
      'Country_EMU': 'European M. Union',
      'Country_ES': 'Spain',
      'Country_FI': 'Finland',
      'Country_FR': 'France',
      'Country_GR': 'Greece',
      'Country_HK': 'Hong Kong',
      'Country_HU': 'Hungary',
      'Country_ID': 'Indonesia',
      'Country_IE': 'Ireland',
      'Country_IL': 'Israel',
      'Country_IN': 'India',
      'Country_IS': 'Iceland',
      'Country_IT': 'Italy',
      'Country_JP': 'Japan',
      'Country_KR': 'South Korea',
      'Country_KW': 'Kuwait',
      'Country_MX': 'Mexico',
      'Country_NL': 'Netherlands',
      'Country_NO': 'Norway',
      'Country_NZ': 'New Zealand',
      'Country_PL': 'Poland',
      'Country_PT': 'Portugal',
      'Country_QA': 'Qatar',
      'Country_RO': 'Romania',
      'Country_RU': 'Russia',
      'Country_SA': 'Saudi Arabia',
      'Country_SE': 'Sweden',
      'Country_SG': 'Singapore',
      'Country_SK': 'Slovakia',
      'Country_TH': 'Thailand',
      'Country_TR': 'Türkiye',
      'Country_UA': 'Ukraine',
      'Country_UK': 'United Kingdom',
      'Country_US': 'United States',
      'Country_VN': 'Vietnam',
      'Country_ZA': 'South Africa',
      'Cover image removed successfully': undefined,
      'Cover image uploaded successfully': undefined,
      'Create an account': undefined,
      'Created': undefined,
      'Credit Card': undefined,
      'CS': undefined,
      'Curated headlines across the assets you trade.': undefined,
      'Currencies': undefined,
      'Currency': 'Currency',
      'Currency_GHS': 'Ghanaian Cedi',
      'Currency_HKD': 'Hong Kong Dollar',
      'Currency_IDR': 'Indonesian Rupiah',
      'Currency_KES': 'Kenyan Shilling',
      'Currency_MYR': 'Malaysian Ringgit',
      'Currency_SGD': 'Singapore Dollar',
      'Currency_THB': 'Thai Baht',
      'Currency_TZS': 'Tanzanian Shilling',
      'Currency_UGX': 'Ugandan Shilling',
      'Currency_USD': 'US Dollar',
      'Currency_VND': 'Vietnamese Dong',
      'Current': undefined,
      'Custom': undefined,
      'Customer Support': undefined,
      'Daily Deposit Limit': undefined,
      'Dashboard': undefined,
      'Date range too large': 'This date range has too many trades, please select a smaller range.',
      'Day Range': undefined,
      'Day_Interval': '(1)[day];(2-inf)[days];',
      'Decrease': undefined,
      'Default': undefined,
      'Delete': undefined,
      'Delete and Notify Author': undefined,
      'Delete comment': undefined,
      'Delete post': undefined,
      'Demo account not supported (Bank Account)': 'Demo Account Not Supported',
      'Demo account not supported (Deposit)': 'Demo Account Not Supported',
      'Demo account not supported (Missions)': 'Missions for Live Account Only',
      'Demo account not supported (Stellar Box)': 'Stellar Box for Live Account Only',
      'Demo account not supported (Transaction)': 'Demo Account Not Supported',
      'Demo account not supported (Withdrawal)': 'Demo Account Not Supported',
      'Demo Trade': undefined,
      'Deposit': undefined,
      'Deposit & Withdrawal': undefined,
      'Deposit A fee might be charged': 'A fee might be charged by third-party deposit partners.\nPlease review the fees before making the deposit.',
      'Deposit A transaction fee': 'A {{transactionFee}} transaction fee will be deducted for deposits below {{waiveTransactionFeeAmount}}.',
      'Deposit A transaction fee in percent': 'A {{transactionFeePercent}} transaction fee will be deducted.',
      'Deposit A transaction fee in zero': 'No transaction fees. All deposits go directly to your account.',
      'Deposit A transaction percentage': 'Upon completion of the deposit procedures, a non-refundable {{transactionFeePercent}} transaction fee on your deposit amount will be charged and deducted directly from your deposit amount.',
      'Deposit Account Number One Time Use': 'This account number is valid for one-time use only.',
      'Deposit add new card': '+ Add new card',
      'Deposit again': undefined,
      'Deposit Amount': undefined,
      'Deposit Amount (currency)': 'Deposit Amount ({{currency}})',
      'Deposit card details': 'Card details',
      'Deposit card secure checkout': 'Card details are entered securely in checkout.',
      'Deposit choose a method': 'Choose a method',
      'Deposit choose another method': 'Choose another method',
      'Deposit complete selected method form': 'Complete the selected method form to continue.',
      'Deposit conversion': 'Conversion',
      'Deposit conversion unavailable': 'Rate unavailable',
      'Deposit Currency': undefined,
      'Deposit error reference': 'Ref: {{reference}}',
      'Deposit fee percent': 'A {{transactionFeePercent}} fee applies.',
      'Deposit fee under waiver': 'A {{transactionFee}} fee applies below {{waiveTransactionFeeAmount}}.',
      'Deposit Fees': undefined,
      'Deposit I have made': 'I have made the deposit',
      'Deposit Important information': 'Important information',
      'Deposit Instruction': undefined,
      'Deposit method unavailable': undefined,
      'Deposit method unavailable body': 'This payment method isn\'t available for {{currency}} in your country. Please choose another method.',
      'Deposit Money': undefined,
      'Deposit Monthly Limit': 'You\'ve exceeded the monthly deposit limit of {{monthlyLimit}} per month.\n\nYou will be contacted by email shortly.',
      'Deposit Monthly Limit for Credit Card': 'You\'ve exceeded the monthly deposit limit of {{monthlyLimit}} per month.\n\nYou will be contacted by email shortly.',
      'Deposit Note': 'Note:\n- The value calculated is based on amount after deducting your bank\'s transfer fee.\n- Deposit and withdrawals will go through anti-money laundering checks which may delay the completion time.',
      'Deposit Official Bank Receipt Display': 'An official bank receipt or screenshot displaying:',
      'Deposit Payment Method BANK_DEPOSIT': 'Bank Deposit',
      'Deposit Payment Method CREDIT_CARD': 'Credit Card',
      'Deposit Payment Method PAYMENT_ASIA': 'Payment Asia',
      'Deposit Payment Method WIRED': 'Wire Transfer',
      'Deposit Payment Provider BRIDGERPAY_APM': 'PaymentAsia',
      'Deposit Payment Provider EPICPAY': 'EpicPay',
      'Deposit Payment Provider PAYMENT_ASIA': 'PaymentAsia',
      'Deposit Payment Reference Important Information':
        'Use your trading account number <accountNumber>{{accountNumber}}</accountNumber> as the payment reference when you make the transfer. Deposits without it will be delayed.',
      'Deposit Payment Reference Required': 'Payment Reference (required)',
      'Deposit Payment Reference Warning Body':
        'Enter <accountNumber>{{accountNumber}}</accountNumber> in the reference / description field of your bank transfer. Deposits sent without this reference cannot be matched to your account and will be delayed until we can verify them manually.',
      'Deposit Payment Reference Warning Title': 'Include your trading account number as the payment reference',
      'Deposit Pending': undefined,
      'Deposit Please deposit to': 'Please deposit to our bank account using the number below.',
      'Deposit processing time': 'Processing time',
      'Deposit processing time pending': 'the estimated processing window',
      'Deposit Proof of Deposit Bank Acct Details': 'Sending and receiving bank account details',
      'Deposit Proof of Deposit Footer':'Note: Transfers from third parties (friends or family) are not accepted. The document must be clear, uncropped, and unaltered.',
      'Deposit Proof of Deposit Legal Name': 'Your full legal name (matching your account name)',
      'Deposit Proof of Deposit Other Details': 'Date, amount, and transaction reference number',
      'Deposit Proof of Deposit Requirement': 'What is needed for Proof of Deposit',
      'Deposit Requested': undefined,
      'Deposit set in form': 'Set in form',
      'Deposit submit failed body': 'We couldn\'t start your deposit. Please check your details and try again.',
      'Deposit submit unavailable body': 'We couldn\'t reach the payment service. Please try again in a moment.',
      'Deposit summary': 'Summary',
      'Deposit summary cta': 'Deposit {{amount}}',
      'Deposit summary funding terms prefix': 'By depositing you agree to the',
      'Deposit summary funding terms suffix': 'Your funds are held in a segregated trust account.',
      'Deposit summary funds arrive': 'Funds typically arrive in {{timing}}.',
      'Deposit summary receive': "You'll receive",
      'Deposit Transaction Limit': 'The daily deposit limit is {{dailyQuota}} per day.\n\nYou can deposit <1>{{remainingQuota}}</1> more today.\nPlease try again.',
      'Deposit under two minutes': 'under 2 minutes',
      'Deposit Unsupported Countries Message': 'Unsupported countries/regions: Afghanistan, China, Cote d\'Ivoire, Iran, Japan, North Korea, Russia.',
      'Deposit USD directly': undefined,
      'Deposit When you have': 'When you have made the deposit, let us know by clicking this button:',
      'Deposit Wire Transfer Timeframe': 'Bank wire transfers usually take 1 to 5 business days to reach us. We will credit your trading account as soon as the funds are confirmed.',
      'Deposit You can make': 'You can make deposits through online and phone banking, bank branch, ATM, local and overseas telegraphic transfer.\nMinimum deposit amount is {{minAmount}}.',
      'Deposit Your deposit request': 'Your deposit request has been sent to our team.\nWe will review it and get back to you as soon as we can.',
      'Deposit Your deposit request cancelled': 'Your deposit request has been cancelled.\nYou can try again by clicking Deposit Again below.\nIf the problem persists, please <0>contact us</0>.',
      'Deposit Your deposit request rejected': 'Your deposit request has been rejected.\nPlease contact your card issuer for details.',
      'Describe your group': undefined,
      'Description': undefined,
      'Didnt receive code': "Didn't receive the code?",
      'Direct': undefined,
      'Disclaimer': undefined,
      'Discover': undefined,
      'Display Leaderboard Message': 'Display my performance in leaderboard and trading stats in profile page.',
      'Display name': undefined,
      'Don\'t Notify me': undefined,
      'Download paragraph': 'Get real time trading alerts, market updates and key financial events on the Alphie Trader app.',
      'E-wallets': undefined,
      'Earlier': undefined,
      'Earlier this week': undefined,
      'Earned on': undefined,
      'Earned Rewards': undefined,
      'Edit': undefined,
      'Edit Comment': undefined,
      'Edit Favourites': undefined,
      'Edit Feed': undefined,
      'Edit group info': undefined,
      'Edit Order': undefined,
      'Edit Position': undefined,
      'Edit Profile': undefined,
      'Edit Trade': undefined,
      'Email': undefined,
      'Email address': undefined,
      'Email cannot be empty': undefined,
      'Email verified': undefined,
      'Ended.': undefined,
      'Ends in:': undefined,
      'Enter a valid limit price.': undefined,
      'Enter the email associated with your account.': undefined,
      'Equity Available': undefined,
      'Equity Available less than Copy Fund': 'Available equity is less than your Copy Fund. Trades that exceed your available equity will be copied at a reduced size. If the affordable size is too small to place, the trade will not be copied.',
      'Equity Left': undefined,
      'Equity Left Definition': 'The equity in your remaining Copy Fund that is available to open new copied trades.',
      'Equity Used': undefined,
      'Equity Used Definition': 'The equity you have used in past copied trades.',
      'Equity Using': undefined,
      'Equity Using Definition': 'The equity in your Copy Fund that is being used to open copied trades.',
      'Error muting channel': undefined,
      'Error unmuting channel': undefined,
      'Est. 1 to 5 business days': undefined,
      'Est. Equity Used': undefined,
      'Event': undefined,
      'Event Unavailable': undefined,
      'Event Unavailable Message': 'The event has expired or is unavailable. Please choose an active event from the financial calendar.',
      'Event_Interval': '(0)[events];(1)[event];(2-inf)[events];',
      'Everyone': undefined,
      'Expand': undefined,
      'Expiration': undefined,
      'Expired on': 'Expired on {{expiryDate}}',
      'Expires at': undefined,
      'Expires on': 'Expires on {{expiryDate}}',
      'Explore Markets': undefined,
      'Failed to change copy trade setting': undefined,
      'Failed to copy to clipboard': undefined,
      'Failed to get copy trade setting': undefined,
      'Failed to get response for uploading avatar': undefined,
      'Failed to get response when removing avatar': undefined,
      'Failed to get response when removing cover image': undefined,
      'Failed to get response when uploading cover image': undefined,
      'Failed to remove uploaded proof of address.': undefined,
      'Failed to remove uploaded proof of identity.': undefined,
      'Failed to save proof of address. It will be uploaded when you submit.': undefined,
      'Failed to save proof of identity. It will be uploaded when you submit.': undefined,
      'Failed to submit the form. Please try again.': undefined,
      'Fair': undefined,
      'FAQ': undefined,
      'Favourites': undefined,
      'Fee': undefined,
      'Feed': undefined,
      'Feed posts': undefined,
      'Feed posts helper text': 'When you have likes, comments, reposts and mentions.',
      'Feedback Submitted': undefined,
      'Filters': undefined,
      'Find instrument': undefined,
      'First deposit': 'You have deposited {{amount}}',
      'Focus Market Empty': 'Browse <1>Focus Markets</1> to discover traders you interested in.',
      'Focus Markets': undefined,
      'Focused Markets': undefined,
      'Followed': undefined,
      'Follower_Interval': '(0)[followers];(1)[follower];(2-inf)[followers];',
      'Followers': undefined,
      'Following': undefined,
      'For any settings, if the unused Copy Fund is less than needed to copy the Kaptain': 'For any settings, if a trade requires more than your unused Copy Fund, it will be copied at a reduced size. If the affordable size is too small to place, the trade will not be copied.',
      'For error codes with an asterisk': 'For error codes with an asterisk (*), please contact your bank or card issuer for further assistance.',
      'For You': undefined,
      'Forget Password?': undefined,
      'forgot password support note': undefined,
      'Forgot password?': undefined,
      'Free margin is not enough for the minimum trade size of {{units}} units': undefined,
      'Frequency': undefined,
      'Frequency_DAY': ' Daily',
      'Frequency_MONTH': 'Monthly',
      'Frequency_QUARTER': 'Quarterly',
      'Frequency_WEEK': 'Weekly',
      'Frequency_YEAR': 'Yearly',
      'Friend': undefined,
      'From': undefined,
      'Full ranking': undefined,
      'Funds requested': undefined,
      'FX': undefined,
      'Gainers': undefined,
      'General': undefined,
      'Get App': undefined,
      'Get daily rewards': 'Get daily up to <1>{{amount}}</1> Rewards',
      'Get Rewards': undefined,
      'Global Indices': undefined,
      'Go to Account Setting': 'Go to <1>Account Settings</1> to display my performance.',
      'Go to Markets': undefined,
      'Go to Transaction History': undefined,
      'Gold': undefined,
      'Good Afternoon': undefined,
      'Good Evening': undefined,
      'Good Luck': undefined,
      'Good Morning': undefined,
      'Good till cancelled': undefined,
      'Good till date': undefined,
      'Group': undefined,
      'Group creator': undefined,
      'Group description': undefined,
      'Group members': undefined,
      'Group Name': undefined,
      'Groups': undefined,
      'GTC': undefined,
      'Guest': undefined,
      'Header Banner': undefined,
      'Help & support': undefined,
      'Hidden Stats - Me': 'You have hidden stats.',
      'Hidden Stats - Trader': 'Trader has hidden stats.',
      'Hidden Trades - Me': 'You have hidden trades.',
      'Hidden Trades - Trader': 'Trader has hidden trades.',
      'Hide password': undefined,
      'High': undefined,
      'High-impact macro events for your watched currencies.': undefined,
      'Historical': undefined,
      'History': undefined,
      'Hold the amount until': 'Hold the amount until {{redemptionDate}}',
      'Holidays and Daylight Savings Time': 'Holidays and Daylight Savings Time can affect product trading hours',
      'Hour_Interval': '(1)[hour];(2-inf)[hours];',
      'I accept the Terms and the Privacy Policy, and confirm I am 18+': undefined,
      'IBAN': undefined,
      'Ideas & Trades': undefined,
      'If all of your Copy Fund is used': 'If all of your Copy Fund is used, new trades from the Ace won\'t be copied.',
      'If the equity used by Kaptain exceeds your Min/Max range': 'If the equity used by Ace exceeds your Min/Max range, the Min or Max limit will be used to copy the trade. You can set the same amount for both limits.',
      'If you would like to adjust your Stop Loss/Take Profit or use Partial Close, you will need to switch off Auto-pilot.': undefined,
      'Impact': undefined,
      'Impact_HIGH': 'High',
      'Impact_LOW': 'Low',
      'Impact_MEDIUM': 'Mid',
      'In-app notifications': undefined,
      'In-app notifications helper text': 'Turn Social and Trade notifications on or off.',
      'Includes at least one number': undefined,
      'Includes at least one special character': undefined,
      'Includes uppercase and lowercase letters': undefined,
      'Increase': undefined,
      'Indicators': undefined,
      'Ineligible to get reward': 'Your total one-off deposit does not meet the minimum requirement.',
      'Input a valid email here': undefined,
      'Input an Username': undefined,
      'Input Your First Name': undefined,
      'Input Your Last Name': undefined,
      'Instant': undefined,
      'Instrument': undefined,
      'Instrument category': undefined,
      'Instrument Info': undefined,
      'Instrument Name': undefined,
      'Instrument not exist': 'The instrument you are looking for does not exists',
      'Instruments': undefined,
      'Invalid GTD': undefined,
      'Invalid input for Maximum per trade or Minimum per trade': undefined,
      'Invalid price, the price must be higher than the current market price.': undefined,
      'Invalid price, the price must be lower than the current market price.': undefined,
      'Invalid Stop Loss Price': undefined,
      'Invalid Take Profit Price': undefined,
      'Join our community now to enjoy exclusive benefits': undefined,
      'Joined': undefined,
      'Kaptain': 'Ace',
      'Kaptain doesn\'t exist.': 'Ace doesn\'t exist.',
      'Kaptain\'s trades': 'Ace\'s trades',
      'Kaptain\'s trades helper text': 'When an Ace opens or closes their trades.',
      'KYC approved': undefined,
      'KYC under review': undefined,
      'KYC under review application last page': 'Your trading account application is currently under review. We’ll notify you by email as soon as there’s an update. Please check your inbox as well as your junk or spam folder.',
      'Last {{numOfMonths}} Months': undefined,
      'Last 3 Months': undefined,
      'Last 6 Months': undefined,
      'Last 12 Months': undefined,
      'Last Month': undefined,
      'Last Quote Time': undefined,
      'Last Week': undefined,
      'Latest Posts': undefined,
      'Leaderboard': undefined,
      'Leaderboard and trading stats': undefined,
      'Least Equity Used': undefined,
      'Least P/L': undefined,
      'Leave': undefined,
      'Leave group': undefined,
      'Leave group content': 'Are you sure you want to leave the group? You will no longer have access to group messages and updates.',
      "Let's deposit money!": undefined,
      "Let's start trading": undefined,
      'Like': undefined,
      'Liked': undefined,
      'Limit': undefined,
      'Limit Order': undefined,
      'Limit Price': undefined,
      'Limit/Stop Price': undefined,
      'Line': undefined,
      'Live Trade': undefined,
      'Live Trade Only': 'Live trading performances only.\nSign up for a live account to show off your results!',
      'Log In': undefined,
      'Log in now to start using Alphie Trader!': undefined,
      'Log Out': undefined,
      'Login alerts': undefined,
      'Login alerts helper text': 'Email + push on every new device',
      'Login or Signup': '<0>Log in</0> or <2>Sign up</2>',
      'Losers': undefined,
      'Loss': undefined,
      'lots': undefined,
      'Low': undefined,
      'Make admin': undefined,
      'Make admin content': 'Are you sure you want to make {{name}} an admin? They will be able to manage group members and group settings.',
      'Manage': undefined,
      'Manual Close': undefined,
      'Margin': undefined,
      'Margin call: Your account needs attention.': undefined,
      'Margin Level': undefined,
      'Margin Stop Out': undefined,
      'Mark all as read': undefined,
      'Mark as read': undefined,
      'Market': undefined,
      'Market Closed': undefined,
      'Market News': undefined,
      'Market open': undefined,
      'Market Order': undefined,
      'Market orders are unavailable while the market is closed. You can place a Limit or Stop order instead.': undefined,
      'Markets': undefined,
      'Markets now': undefined,
      'Max Drawdown': undefined,
      'Max Drawdown Backfilled': 'Includes estimated history before daily equity tracking began.',
      'Max Drawdown Definition': 'Largest fall in account equity from its highest point in this period, as a percentage of that high. Deposits and withdrawals don\'t count.',
      'Max Leverage Information': undefined,
      'Maximize your potential': 'Maximize your potential',
      'Maximum deposit': 'Maximum deposit: {{amount}}',
      'Maximum per trade': undefined,
      'Maximum per trade cannot be larger than Copy Fund': undefined,
      'Maximum trade size is {{units}} units': undefined,
      'Maximum withdrawal': 'Maximum withdrawal: {{maxAmount}}',
      'Member': undefined,
      'Members': undefined,
      'Menu': undefined,
      'Message': undefined,
      'Method': undefined,
      'Migration Description': 'Upgrade Live Account to enjoy 500x leverage! With higher leverage, you can amplify your trading positions and increase your returns.',
      'Min / Max': undefined,
      'Min/Max': undefined,
      'Min/Max Trading Volume': undefined,
      'Minimum deposit': 'Minimum deposit: {{amount}}',
      'Minimum per trade': undefined,
      'Minimum per trade cannot be larger than Copy Fund': undefined,
      'Minimum per trade cannot be larger than Maximum per trade': undefined,
      'Minimum per trade or Maximum per trade cannot be 0': undefined,
      'Minimum size 150x150': undefined,
      'Minimum size 1636x273': undefined,
      'Minimum withdrawal': 'Minimum withdrawal: {{minAmount}}',
      'Minimum XXX': 'Minimum {{minAmount}}',
      'Minute_Interval': '(1)[minute];(2-inf)[minutes];',
      'Mission start': undefined,
      'Missions end in:': undefined,
      'Missions ended.': undefined,
      'Missions start in:': undefined,
      'Mixed': undefined,
      'Month': undefined,
      'Monthly return past months': 'Monthly return, past {{count}} months',
      'More': undefined,
      'Most Active': undefined,
      'Most Copiers': undefined,
      'Most Equity Used': undefined,
      'Most Followers': undefined,
      'Most P/L': undefined,
      'Most Traded': undefined,
      'Move to top': undefined,
      'Mute': undefined,
      'Mute notifications': undefined,
      'My Badges': undefined,
      'My badges': undefined,
      'My Feed Empty': 'Browse <1>Social Feed</1> to discover traders\' ideas.',
      'My Missions': undefined,
      'My Stellar Rewards': undefined,
      'My Trades': undefined,
      'N/A': undefined,
      'Name your group': undefined,
      'Net P/L': undefined,
      'New chat': undefined,
      'New copier': undefined,
      'New copier helper text': 'When someone has started copying your trades.',
      'New followers': undefined,
      'New followers helper text': 'When someone has followed you.',
      'New here?': undefined,
      'New notifications will show up here.': undefined,
      'New Trade Followers': undefined,
      'News': undefined,
      'Next': undefined,
      'Next Month': undefined,
      'Next Release': undefined,
      'Next Week': undefined,
      'No Active Kaptains': 'No Active Aces',
      'No available campaign': undefined,
      'No campaign available now.': undefined,
      'No CapitalPay account': undefined,
      'No Chats': undefined,
      'No Closed Trades': undefined,
      'No credit card': undefined,
      'No data to display': undefined,
      'No events found': undefined,
      'No instruments found': undefined,
      'No Kaptains': 'No Aces',
      'No Kaptains Message': 'Go to <1>Leaderboard</1> to discover potential Aces to copy.',
      'No match': undefined,
      'No Messages': undefined,
      'No Open Trades': undefined,
      'No Past Kaptains': 'No Past Aces',
      'No Pending Trades': undefined,
      'No people found': undefined,
      'No picks for you yet': undefined,
      'No posts about {{instrument}} yet': undefined,
      'No posts about this instrument yet': undefined,
      'No Related News': undefined,
      'No rewards in this period': undefined,
      'No Search Result': 'Your search did not match any {{type}} results.',
      'No spaces and non-standard characters': undefined,
      'No Stats': undefined,
      'No traders.': undefined,
      'No trades found.': undefined,
      'No trades in this period.': undefined,
      'No transactions found.': undefined,
      'No upcoming events.': undefined,
      'No updates yet': undefined,
      'Not copying': undefined,
      'Not earned yet': undefined,
      'Not enough available equity': undefined,
      'Not enough equity available': undefined,
      'Not Found': 'The resource you were looking for could not be found.',
      'Not set': undefined,
      'Not verified': undefined,
      'Nothing yet': 'Nothing yet...',
      'Notification settings': undefined,
      'Notifications': undefined,
      'Notify Me': undefined,
      'Notify Me on new trades': undefined,
      'Notional': undefined,
      'Notional Value': undefined,
      'Notional Value definition': 'Notional value is calculated by multiplying units/contracts and instrument price in USD.',
      'Oil': undefined,
      'OK': undefined,
      'Online': undefined,
      'Only .jpg/.png/.bmp/.pdf is supported.': undefined,
      'Only notify me on live trades': undefined,
      'Only notify me on live trades helper text': 'You won’t be notified on demo trades.',
      'Open': undefined,
      'Open 5 live trades to get a Stellar Box': undefined,
      'Open copied trades': undefined,
      'Open emoji picker': undefined,
      'Open more': undefined,
      'Open Price': undefined,
      'Open Trade': undefined,
      'Open Trades': undefined,
      'Open/Prev Close': undefined,
      'Opened {{filled}} of {{requested}} units': undefined,
      'Opened at': undefined,
      'Optional': undefined,
      'Or your code': undefined,
      'Order estimate': 'Required Margin',
      'Order executed': undefined,
      'Order Executed': undefined,
      'Order executed helper text': 'When your limit or stop order has opened, or any orders closed by Stop Loss/Take Profit.',
      'Order ID': undefined,
      'Order Placed': undefined,
      'Order placed': undefined,
      'Order type': undefined,
      'Orders execute at market price. Slippage may apply.': undefined,
      'Others': undefined,
      'P&L': undefined,
      'P/L': undefined,
      'Partial Close': undefined,
      'Password': undefined,
      'Past 6 months performance': undefined,
      'Past 12 months performance': undefined,
      'past 24h': undefined,
      'Past Copiers': undefined,
      'Past Copy Funds Used': undefined,
      'Past Copy Funds Used Def': 'The total equity used by past copiers to copy this Ace.',
      'Past Kaptain': 'Past Ace',
      'Past Kaptains': 'Past Aces',
      'Payee Address': undefined,
      'Payment methods': undefined,
      'PaymentAsia (IDR)': undefined,
      'Pending': undefined,
      'Pending box definition': "Pending Stellar Boxes can be opened on the next day starting from 21:00 UTC. We'll notify you when they are ready.",
      'Pending Trade': undefined,
      'Pending Trades': undefined,
      'People': undefined,
      'Performance': undefined,
      'Performance unavailable': 'Performance figures are unavailable right now. Please try again later.',
      'Period': undefined,
      'Phone': undefined,
      'Pin': undefined,
      'Pin to page': undefined,
      'Pinned': undefined,
      'pips': undefined,
      'Place Buy Order': undefined,
      'Place order': undefined,
      'Place Sell Order': undefined,
      'Please check your filters.': undefined,
      'Please enter a valid email': undefined,
      'Please fill in bank account number.': undefined,
      'Please fill in bank name.': undefined,
      'Please input multiple of step volume': undefined,
      'Please login or signup first': undefined,
      'Please re-upload the required identity documents before submitting.': undefined,
      'Please select a date range within 31 days': undefined,
      'Please select a live account (Bank Account)': 'Please select a live account to view your bank accounts.',
      'Please select a live account (Deposit)': 'Please select a live account to deposit money into.',
      'Please select a live account (Missions)': 'Please switch to live account to complete the missions.',
      'Please select a live account (Stellar Box)': 'Please switch to live account to receive Stellar Boxes.',
      'Please select a live account (Transaction)': 'Please select a live account to check transaction history.',
      'Please select a live account (Withdrawal)': 'Please select a live account to withdraw money from.',
      'Please select other options.': undefined,
      'Please set the Copy Fund to copy trades': 'Please set the Copy Fund that will be used to copy {{username}}\'s trades.',
      'Please sign up a live account (Bank Account)': 'Please sign up a live account to view your bank accounts.',
      'Please sign up a live account (Deposit)': 'Please sign up a live account to deposit money into.',
      'Please sign up a live account (Missions)': 'Please sign up a live account to complete the missions.',
      'Please sign up a live account (Stellar Box)': 'Please sign up a live account to receive Stellar Boxes.',
      'Please sign up a live account (Transaction)': 'Please sign up a live account to check transaction history.',
      'Please sign up a live account (Withdrawal)': 'Please sign up a live account to withdraw money from.',
      'Please sign up a live account to view this trade': undefined,
      'Please specify an amount higher than or equal to amount': 'Please specify an amount higher than or equal to {{amount}}.',
      'Please specify an amount lower than amount': 'Please specify an amount lower than {{amount}}.',
      'Please upgrade to new license to (Missions)': 'Please upgrade to new license to complete the missions.',
      'Please upgrade to new license to (Stellar Box)': 'Please upgrade to new license to receive Stellar Boxes.',
      'Please upload a file less than {{maxSize}}.': undefined,
      'Please upload an image in one of these formats: {{formats}}': undefined,
      'Please upload an image less than {{fileUpdateSizeLimit}}': undefined,
      'Please upload each file < 2mb': undefined,
      'Please upload your bank statement': 'Please upload your bank statement showing your name, address and account details.',
      'Please upload your bank transfer receipt.': undefined,
      'Portfolio': undefined,
      'Position Closed': undefined,
      'Position closed': undefined,
      'Position ID': undefined,
      'Post': undefined,
      'Preferences': undefined,
      'Prev Close': undefined,
      'Preview': undefined,
      'Previous': undefined,
      'Privacy Policy': undefined,
      'Profile': undefined,
      'Profile Picture': undefined,
      'Profit': undefined,
      'Profitable': undefined,
      'Proof of bank account': undefined,
      'Public': undefined,
      'Purpose of Remittance': undefined,
      'Range': undefined,
      'Rank #{{rank}}': undefined,
      'Ratio': undefined,
      'Ratio per trade': undefined,
      'Ratio per trade must be between 1.00% and {{maxTradeRatioPercentage}}.': undefined,
      'Reached the maximum copier limit': '{{kaptainName}} has reached the maximum copier limit. Please copy another Ace.',
      'React': undefined,
      'Read': 'read',
      'Read brief': undefined,
      'Read more': undefined,
      'Received From You': undefined,
      'Receiving Method': undefined,
      'Recent & Next': undefined,
      'Recents': undefined,
      'Refer a friend': undefined,
      'Refer a trader': undefined,
      'Refer Copy Link Message': 'Hey, I use Alphie Trader for social trading and it\'s amazing! Use this link to sign up and start copying my trades. Let\'s make great profits together:',
      'Refer Headline': 'Earn $50 when you refer a friend.',
      'Refer Hero Body': 'They sign up with your link, fund their account, and complete their first trades — and you get a $50 USD bonus.',
      'Refer Link Header': 'Your referral link',
      'Refer Message': 'Earn a bonus of $50 USD when you refer a friend to Alphie Trader!',
      'Refer Step 1': 'Sign up with your link',
      'Refer Step 1 details': 'Verify their identity and get a live account',
      'Refer Step 2': 'Deposit to their account',
      'Refer Step 2 details': 'Make a minimum deposit of $100 USD',
      'Refer Step 3': 'Complete 10 transactions',
      'Refer Step 3 details': 'Eg: Open 10 trades, or open and close 5 trades',
      'Refer Step Header': 'Steps for your friends',
      'Referral Code': undefined,
      'Referral program T&C': 'Terms & Conditions',
      'Referral T&C prefix': '*',
      'Referral T&C suffix': 'apply.',
      'Refill not available': 'The request is only available when your balance is below $10,000',
      'Refresh': undefined,
      'Related News': undefined,
      'Remarks': undefined,
      'Remember me': undefined,
      'Remembered it?': undefined,
      'Remove': undefined,
      'Remove admin': undefined,
      'Remove admin content': 'Are you sure you want to remove {{name}} as an admin? They will no longer able to manage group members and group settings.',
      'Remove as admin': undefined,
      'Remove from group': undefined,
      'Remove group photo': undefined,
      'Remove member': undefined,
      'Remove member content': 'Are you sure you want to remove {{name}} from the group? They will no longer be able to send or receive new messages.',
      'remove spaces and special characters': undefined,
      'Reply': undefined,
      'Reply to': undefined,
      'Report': undefined,
      'Repost to my profile': undefined,
      'Required': undefined,
      'Resend code': undefined,
      'Resend code in': undefined,
      'Resend link': 'to log in again and we’ll resend a new link to your email.',
      'Reset': undefined,
      'Reset Password': undefined,
      'Reset your password': undefined,
      'Retry': undefined,
      'Return': undefined,
      'Return %': undefined,
      'Return (12M)': undefined,
      'Returned': undefined,
      'Review deposits, withdrawals, copy trading activity, rewards, and adjustments.': undefined,
      'Reward': undefined,
      'Reward box count': 'in {{count}} boxes',
      'Reward Breakdown': undefined,
      'Reward History': undefined,
      'Reward Type': undefined,
      'rewards': undefined,
      'Rewards hub': undefined,
      'Risk/Reward Ratio': undefined,
      'Rocket To Reward': undefined,
      'Rocket To Rewards': undefined,
      'ROE': undefined,
      'Rules and Terms': undefined,
      'Save': undefined,
      'Save Account': undefined,
      'Saved': undefined,
      'Scroll to zoom in/out': undefined,
      'Search': undefined,
      'Search conversations': undefined,
      'Search for traders': undefined,
      'Search markets, traders, news...': undefined,
      'Search unavailable. Please try again.': undefined,
      'Second_Interval': '(0)[seconds];(1)[second];(2-inf)[seconds];',
      'Security': undefined,
      'Security Settings': undefined,
      'See all': undefined,
      'See all chats': undefined,
      'See all notifications': undefined,
      'See less': undefined,
      'See more': undefined,
      'Seen by': undefined,
      'Select a bank': undefined,
      'Select a message': undefined,
      'Select bank transfer to withdraw': undefined,
      'Select Date': undefined,
      'Sell': undefined,
      'Sell Limit': undefined,
      'Sell Stop': undefined,
      'Send': undefined,
      'Send gif fail': 'Failed to send gif, please try again',
      'Send reset link': undefined,
      'Sender Address': undefined,
      'Sender City': undefined,
      'Sender Post Code': undefined,
      'Sender State': undefined,
      "Sending": undefined,
      'Sent To You': undefined,
      'Session Expired Action Reminder': 'Your session has expired. Please sign in again.',
      'Set Alert': undefined,
      'Set the equity limit to be used for each trade': undefined,
      'Share': undefined,
      'Share All': undefined,
      'Share Event': undefined,
      'Share this Order': undefined,
      'Share your ideas': undefined,
      'Sharpe Ratio': undefined,
      'Sharpe Ratio Definition': 'Return per unit of volatility, from daily returns (0% risk-free rate, annualised). Shown once equity has changed on at least 20 days in the period.',
      'Show notional value': undefined,
      'Show password': undefined,
      'Show summary for closed single trades': undefined,
      'Show summary for closed stacked trades': undefined,
      'Show summary for opened trades': undefined,
      'Show unread only': undefined,
      'Side': undefined,
      'Sign In': undefined,
      'Sign in to continue trading.': undefined,
      'Sign Up': undefined,
      'Sign up for a new account': undefined,
      'Sign Up Live': undefined,
      'Sign Up Live Account': undefined,
      'Sign up message': 'Please enter the 6-digit verification code sent to',
      'Sign up now': undefined,
      'Sign up or log in to share your ideas!': undefined,
      'Similar Instruments': undefined,
      'Single trade limit': undefined,
      'SLTP Black New': '<0>Grey</0> - Your equity used.',
      'SLTP Black Update': '<0>Grey</0> - Equity used by Ace.',
      'SLTP Green': '<0>Green</0> - Within your 80% equity available.',
      'SLTP Kopy Trade': 'You cannot copy an Ace when your equity available is below 0.',
      'SLTP Red': '<0>Red</0> - Above your 80% equity available.',
      'SLTP Regular Trade': 'Order cannot be placed when your equity available is below 0.',
      'Social Feed': undefined,
      'Social notifications': undefined,
      'Something went wrong': undefined,
      'Something went wrong. Please try again.': undefined,
      'Sort by': undefined,
      'Sortino Ratio': undefined,
      'Sortino Ratio Definition': 'Like Sharpe, but counts only downside volatility (0% minimum return, annualised). Shown once equity has changed on at least 20 days in the period.',
      'Source': undefined,
      'Spread': undefined,
      'Standard bank transfer': undefined,
      'Start': undefined,
      'Start a new conversation': undefined,
      'Start chat': undefined,
      'Start copy trade': undefined,
      'Start trading': undefined,
      'Start trading and we’ll surface markets picked for you.': undefined,
      'Starts in:': undefined,
      'Stats': undefined,
      'Status': undefined,
      'Stay signed in': undefined,
      'Stellar Box': undefined,
      'Stellar Boxes': 'Stellar Boxes <1>x {{boxCount}}</1>',
      'Stop': undefined,
      'Stop Auto-pilot': undefined,
      'Stop copy trade': undefined,
      'Stop copy trade failed': undefined,
      'Stop copying': undefined,
      'Stop Loss': undefined,
      'Stop Loss Triggered': undefined,
      'Stop Order': undefined,
      'Stop Price': undefined,
      'Strive for greater rewards next time!': undefined,
      'Strong': undefined,
      'Subject': undefined,
      'Submit': undefined,
      'Subscribe': undefined,
      'Support hotline:': undefined,
      'Support Request': undefined,
      'Swap': undefined,
      'Swap Definition':
        'A swap is the interest earned or paid for holding a trade overnight. SWAP FREE accounts do not accrue new overnight swap charges. Previously posted swap may still appear in positions and transaction history.',
      'Swap Long/Short': undefined,
      'Swift Code': undefined,
      'Swift code is 8 to 11 characters': 'A SWIFT code is 8 to 11 characters',
      'Switch Account': undefined,
      'Switch Account Message': 'Please switch to {{targetAccountType}} Account to view this trade',
      'Switch Account Notify': 'Switched to {{accountType}} Account',
      'Switch to Live Account': undefined,
      'Symbol': undefined,
      'T&C': 'Terms and Conditions',
      'Tag @Users, $instruments or use #hashtags': undefined,
      'Take Profit': undefined,
      'Take Profit Triggered': undefined,
      'Tell other traders something about you!': undefined,
      'Terms & Conditions': undefined,
      'The latest two earned badges will be featured.': undefined,
      'The podium': undefined,
      'Their future trades will not be copied': undefined,
      'There are no posts right now': undefined,
      'There is no news right now': undefined,
      'There is no related news right now': undefined,
      'There\'s an issue with the liquidity provider. Please reach out to your account manager or start a chat with our support team.':
        undefined,
      'This is taking longer than usual. We are still placing your order.': undefined,
      'This Month': undefined,
      'This post opens on our website.': undefined,
      'This Week': undefined,
      'Time': undefined,
      'Timeframe': undefined,
      'To': undefined,
      'Today': undefined,
      'Today\'s high': undefined,
      'Today\'s High/Low': undefined,
      'Today\'s low': undefined,
      'Tomorrow': undefined,
      'Top {{period}} · global · all assets': undefined,
      'Top Gainers': undefined,
      'Top Losers': undefined,
      'Top Movers': undefined,
      'Top performers across the platform. Follow to copy their trades into your portfolio.': undefined,
      'Top Profits': undefined,
      'Top story': undefined,
      'Total Copiers': undefined,
      'Total Copy Funds Used': undefined,
      'Total Copy Funds Used Def': 'The cumulative equity used for closed copied trades by current and past copiers of this Ace.',
      'Total Trades': undefined,
      'Trade': undefined,
      'Trade completion': undefined,
      'Trade completion message': 'Display a completion summary after you’ve opened or closed any trades.',
      'Trade confirmation': undefined,
      'Trade confirmation message': 'Display a confirm message before you open or close a trade at market price.',
      'Trade details': undefined,
      'Trade in your pocket 24/7': undefined,
      'Trade notifications': undefined,
      'Trade whatever they are trading, automatically': 'trade whatever they are trading, automatically',
      'Trader': 'trader',
      'Trader doesn\'t have any posts.': undefined,
      'Trader doesn\'t have any trades.': undefined,
      'Traders': 'traders',
      'Trades': undefined,
      'Trades Until Next Box': undefined,
      'Trading': undefined,
      'Trading Credits': 'Power Token',
      'Trading Credits Abb': 'P-Token',
      'Trading credits definition': 'Power Token increases your equity available until it expires, staying at a 1:1 ratio with your balance if it drops below your Power Token.',
      'Trading Hours': undefined,
      'Trailing SL': undefined,
      'Trailing Stop Loss': undefined,
      'Transaction Fee': undefined,
      'Transaction History': undefined,
      'Transaction ID': undefined,
      'Trending': undefined,
      'Trending Now': undefined,
      'Try another transaction type or date range.': undefined,
      'Turning off Auto-pilot': 'Turning off Auto-pilot lets you Partial Close and edit Stop Loss/Take Profit for this trade. It will not auto close when the Ace closes their trade.',
      'Two-factor authentication': undefined,
      'Two-factor authentication helper text': 'App-based authenticator',
      'Type': undefined,
      'Type a message': undefined,
      'Type in your message': undefined,
      'Type to search for traders': undefined,
      'Unit': undefined,
      'Units': undefined,
      'Units/Contracts': undefined,
      'Unmute': undefined,
      'Unpin': undefined,
      'Unread': undefined,
      'Unreport': undefined,
      'Unsubscribe': undefined,
      'Unsupported file type. Please upload a JPG, PNG, BMP or PDF.': undefined,
      'Unverified': undefined,
      'Updated': undefined,
      'Upgrade Live Account to enjoy 500x leverage!': undefined,
      'Upgrade now': undefined,
      'Upload avatar successfully': undefined,
      'Upload bank statement': undefined,
      'Upload Receipt': undefined,
      'use at least 8 characters': undefined,
      'Username': undefined,
      'Username already exists.': undefined,
      'Username must be numbers or letters only (0-9, A-Z, a-z)': undefined,
      'Using of your equity': 'Using {{percentage}}% of your equity',
      'Value': undefined,
      'Verification Code': undefined,
      'Verification pending': undefined,
      'Verified': undefined,
      'Verify now': undefined,
      'Verify your email': undefined,
      'Very strong': undefined,
      'View': undefined,
      'View All Results': undefined,
      'View copied trades': undefined,
      'View more comments': undefined,
      'View profile': undefined,
      'View trade': undefined,
      'Virtual Funds': undefined,
      'Virtual Funds Requested': undefined,
      'Volume': undefined,
      'We convert USD for you': undefined,
      'We could not read that file. Please try another photo or PDF.': undefined,
      "We couldn't check your maximum trade size. Try again shortly": undefined,
      "We couldn't validate this order. Try again shortly": undefined,
      'We sent a verification code to': undefined,
      'We will reply to you as soon as possible.': undefined,
      'We\'ve sent your password reset instructions to': undefined,
      'Weak': undefined,
      'Week': undefined,
      'Welcome back': undefined,
      'Welcome to Copy Trading': undefined,
      'What\'s going on with this post': undefined,
      'What\'s New': undefined,
      'What\'s so special about this event?': undefined,
      'Win': undefined,
      'Win Rate': undefined,
      'Win up to Bonus Rewards': 'Win up to {{amount}} Bonus Rewards',
      'Wins': undefined,
      'Wire Transfer': undefined,
      'Withdraw': undefined,
      'Withdraw confirmation by email': undefined,
      'Withdraw confirmation by email coming soon':
        'Coming soon — email confirmation not yet available.',
      'withdraw: insufficient funds': "Insufficient funds. Your equity available is {{amount}}",
      'Withdrawal': undefined,
      'Withdrawal A transaction fee': 'A {{transactionFee}} transaction fee will be deducted.',
      'Withdrawal A transaction fee in percent': 'A {{transactionFeePercent}} transaction fee will be deducted.',
      'Withdrawal A transaction fee in zero': 'No transaction fees. All withdrawals go directly to your account.',
      'Withdrawal Account': undefined,
      'Withdrawal Amount': 'Withdrawal Amount',
      'Withdrawal Destination': undefined,
      'Withdrawal error reference': 'Ref: {{reference}}',
      'Withdrawal Fees': undefined,
      'Withdrawal Limit': undefined,
      'Withdrawal limit is the deposited': 'Withdrawal limit is the deposited amount per credit card within {{days}} days. Profits exceeding the limit must be withdrawn to a bank account.',
      'Withdrawal margin too low': 'Not enough free margin',
      'Withdrawal margin too low body': 'Withdrawing this amount would leave too little margin to support your open positions. You can withdraw up to {{maxWithdrawable}} right now. To withdraw more, close some positions first.',
      'Withdrawal Note': 'Note:\n- Your withdrawal fund will be frozen once you submit the request.\n- Deposit and withdrawals will go through anti-money laundering checks which may delay the completion time.',
      'Withdrawal Please submit': 'Please submit a withdrawal request.',
      'Withdrawal Policy Agree': 'I have read and understood AlphieTrader’s <1>Withdrawal Policy</1> by submitting the withdrawal request.',
      'Withdrawal reminder': 'You can withdraw funds up to the minimum value of your balance or equity available.\nPlease ensure that sufficient margins are available to avoid stop out.',
      'Withdrawal submit failed body': 'We couldn\'t submit your withdrawal request. Please try again.',
      'Withdrawal Your request for': 'Your request for withdrawal is submitted.',
      'Write a comment': undefined,
      'Yesterday': undefined,
      'You': undefined,
      'You agree to our Terms & Conditions when you continue': 'You agree to our <1>Terms & Conditions</1> when you continue',
      'You are not logged in.': undefined,
      'You are now copying user': 'You are now copying {{friendlyName}}',
      'You can add an additional bank account': 'You can add an additional bank account for withdrawals. If you want to add more, just deposit into Alphie Trader and they will appear here as options.',
      'You can change it later': undefined,
      'You can withdraw to your accounts below.': undefined,
      'You cannot undo this': 'You can\'t undo this.',
      'You don\'t have any favourite instruments.': undefined,
      'You don\'t have any posts.': undefined,
      'You don\'t have any trades.': undefined,
      'You have': undefined,
      'You have no trades yet': undefined,
      'You have stopped copying user': 'You have stopped copying {{friendlyName}}',
      'You have to close all the copied trades from them before you can copy again': 'You have to close all the copied trades from them before you can copy again.',
      'You still have open copied trades from KaptainName': 'You still have open copied trades from {{kaptainName}}.',
      'You · @{{name}}': undefined,
      "You're all caught up": undefined,
      'You\'ve reached the maximum number of files': undefined,
      'Your account only have withdraw limits': 'Your account only have {{amount}} to withdraw.',
      'Your application was received, but some documents did not upload. Please submit again to finish uploading them.':
        undefined,
      'Your email': undefined,
      'Your email goes here': undefined,
      'Your email is verified.': undefined,
      'Your feedback has been sent to support team.': undefined,
      'Your friends': undefined,
      'Your margin level is {{marginLevel}}. Deposit funds or close positions. If your margin level falls to {{stopOutLevel}}, positions will be closed automatically.':
        undefined,
      'Your Message': undefined,
      'Your open copied trades will remain open': undefined,
      'Your position is closed.': undefined,
      'Your request for virtual funds may take up to 48 hours': undefined,
    }
  },
};

export default Translation;
